import { apiClient } from './apiClient';
import { AvailabilityResponse } from '../types/booking.types';

/**
 * Date availability info with slot counts
 */
export interface DateAvailabilityInfo {
  date: string;
  availableSlots: number;
  totalSlots: number;
}

export const availabilityApi = {
  /**
   * Get available time slots for a specific date, therapist, and service
   */
  async getAvailability(params: {
    therapistId: string;
    serviceId: string;
    date: string; // YYYY-MM-DD format
  }): Promise<AvailabilityResponse> {
    const queryParams = new URLSearchParams({
      therapistId: params.therapistId,
      serviceId: params.serviceId,
      date: params.date,
    });

    const response = await apiClient.get<{ success: boolean; data: AvailabilityResponse }>(
      `/api/bookings/availability?${queryParams.toString()}`
    );

    return response.data.data;
  },

  /**
   * Get available dates for a therapist and service (next N days)
   * Returns slot counts for each date to enable available/limited/unavailable status
   */
  async getAvailableDates(params: {
    therapistId: string;
    serviceId: string;
    startDate: string;
    endDate: string;
  }): Promise<DateAvailabilityInfo[]> {
    const queryParams = new URLSearchParams({
      therapistId: params.therapistId,
      serviceId: params.serviceId,
      startDate: params.startDate,
      endDate: params.endDate,
    });

    const response = await apiClient.get<{ success: boolean; data: DateAvailabilityInfo[] }>(
      `/api/bookings/available-dates?${queryParams.toString()}`
    );

    return response.data.data;
  },
};
